/**
 * 「待归档」虚拟文件夹 · 前端合成项
 *
 * 后端 /web/folder/ai/get 不返回这个文件夹。前端在「文件夹列表非空」时，
 * 把这个虚拟项固定追加到列表末尾，作为"未被归类到任何文件夹的照片"的入口。
 * （feat/0614：后端不再下发待归档数量，虚拟项不再依赖照片张数、也不展示张数）
 *
 * 它不进入真实数据集 folders，因此天然不参与多选 / 全选 / 框选 / 拖拽 / 批量删除；
 * 渲染层据 folderId === UNCLASSIFIED_FOLDER_ID 或 folder.virtual 走精简分支。
 */

import type { FolderListItem } from '../../../../types/ai-classify'

/** 虚拟项 folderId · 用 sentinel 与真实数字 folderID 区分，渲染 / 点击分支据此判断 */
export const UNCLASSIFIED_FOLDER_ID = '__unclassified__'

/** 虚拟项展示名 */
export const UNCLASSIFIED_FOLDER_NAME = '待归档'

/** 待归档详情页路由 · 独立于数字 folderId 详情页 /ai-classify/folder/:folderId */
export const UNCLASSIFIED_DETAIL_ROUTE = '/ai-classify/unclassified'

/**
 * 构造「待归档」虚拟文件夹项。
 *
 * @param photoCount - 未归类照片数（feat/0614 起后端恒 0，仅占位，不展示）
 * @returns 标记了 virtual 的 FolderListItem，可直接喂给 FolderCard / FolderRow
 *
 * @example
 * ```ts
 * buildUnclassifiedFolder(128) // { folderId: '__unclassified__', folderName: '待归档', photoCount: 128, virtual: true, ... }
 * ```
 */
export function buildUnclassifiedFolder(photoCount: number): FolderListItem {
  return {
    folderId: UNCLASSIFIED_FOLDER_ID,
    folderName: UNCLASSIFIED_FOLDER_NAME,
    folderType: 0,
    photoCount,
    subfolderCount: 0,
    ctime: 0,
    updateTime: 0,
    virtual: true
  }
}
